import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {PageContent} from '@app/models/help/pagecontent.model';

@Injectable({providedIn: "root"})

export class PageContentService {

  private service = 'PageContentService';

  constructor(private http: HttpClient) {

  }

  public get(id: number) {
    return this.http.get(`api/${this.service}/get/${id}`);
  }

  public getList() {
    return this.http.get(`api/${this.service}/list`);
  }

  public search(type?: number, keyword?: string, selectedFunctionId?: number) {
    return this.http.get(`api/${this.service}/search?sectionId=${type == null ? 0 : type}&keyword=${keyword}&functionId=${selectedFunctionId ? selectedFunctionId : 0}`);  }

  public insert(pageContent: PageContent) {
    return this.http.post(`api/${this.service}/insert`, pageContent);
  }

  public update(pageContent: PageContent) {
    return this.http.put(`api/${this.service}/update`, pageContent);
  }

  public delete(id) {
    return this.http.delete(`api/${this.service}/delete/${id}`);
  }

  public uploadImage(formData) {
    return this.http.post(`api/${this.service}/upload-image`, formData, {reportProgress: true, observe: 'events'});
  }
}
